<template>
    <app-content>
        <form action="#">
            <div class="inner">
                <app-content-top-nav
                        mainItemLinkName="countries"
                />
                <p class="buttons">
                    <app-button-delete @click="deleteItem" v-if="!newItem"/>
                </p>
                <app-content-title v-if="!newItem && !pending && !deleting"
                                   :title="item.countryNames[currentLanguageId]"/>
                <app-content-title v-if="newItem" :title="translations.newCountry"/>
            </div>
            <app-tabs
                    :colsTabs="columnTabs"
                    :shouldLoadFirstTab="newItem"
                    :loadTab="params.tab"
                    @appTabChanged="onAppTabChanged"
            >
                <div :title="translations.information">
                    <app-settings @submit="onFormSubmit" :disabled="pending">
                        <app-settings-content>
                            <app-settings-desc :title="translations.basicInfo">
                                <p>
                                    <translate>Založeno</translate>
                                    :<br/>
                                    <span v-html="formatDateAdvanced(item._created)"/>
                                </p>
                            </app-settings-desc>

                            <app-settings-options>
                                <app-settings-col class="field_left">
                                    <app-input
                                            :label="translations.isoCode"
                                            required
                                            :error="errors.items.find(el => el.field === 'isoCode')"
                                            v-model="formItem.isoCode"
                                            name="isoCode"

                                    />

                                    <template v-if="!newItem && !deleting">
                                        <template v-for="(language, key) in languages">
                                            <app-input
                                                required
                                                :label="countryTitleText + ' ' + language.languageName"
                                                :error="errors.items.find(el => el.field === 'countryNames' && el.inputField == language._id)"
                                                v-model="formItem.countryNames[language._id]"
                                                :name="`transObj-countryNames-${language._id}`"
                                            />
                                        </template>
                                    </template>
                                    <template v-else>
                                        <template v-for="(language, key) in languages">
                                                <app-input
                                                    required
                                                    :label="countryTitleText + ' ' + language.languageName"
                                                    :error="errors.items.find(el => el.field === 'countryNames' && el.inputField == language._id)"
                                                    :name="`transObj-countryNames-${language._id}`"
                                                />
                                        </template>
                                    </template>
                                </app-settings-col>

                                <app-settings-col class="field_right">
                                    <app-settings-control class="checkbox">
                                        <app-checkbox
                                            name="showInDashboard"
                                            :title="translations.showInDashboard"
                                            :disabled="pending"
                                            v-model="formItem.showInDashboard"
                                        />
                                    </app-settings-control>

                                    <app-image-input
                                        name="countryLandscape"
                                        pClass="field field_poster"
                                        :labelTitle="translations.countryLandscape"
                                        labelClass="photo add_profile_image"
                                        :text="translations.uploadCountryLandscape"
                                        spanClass="sizes"
                                        ref="countryLandscape"
                                        :image="watchedItem.countryLandscape"
                                        :imageLink="countryLandscapeLink"
                                        :disabled="pending"
                                        :error="!!errors.first('countryLandscape')"
                                        @fileChanged="onCountryLandscapeChanged"
                                    />

                                    <app-image-input
                                        name="countryFlag"
                                        pClass="field field_poster"
                                        :labelTitle="translations.countryFlag"
                                        labelClass="icon add_profile_image"
                                        :text="translations.uploadCountryFlag"
                                        spanClass="sizes"
                                        ref="countryFlag"
                                        :image="watchedItem.countryFlag"
                                        :imageLink="countryFlagLink"
                                        :disabled="pending"
                                        :error="!!errors.first('countryFlag')"
                                        @fileChanged="onCountryFlagChanged"
                                    />
                                </app-settings-col>
                            </app-settings-options>
                        </app-settings-content>

                        <app-settings-buttons :navLinkTitle="translations.list" :nav-link-to="{ name: 'countries' }">
                            <app-content-save-button :disabled="pending" @click="disallowBack"/>
                        </app-settings-buttons>
                    </app-settings>
                </div>
                <div
                        :title="translations.synonyms + ' (' + (item.synonyms ? item.synonyms.length : 0) + ')'"
                        :data-disabled-title="translations.synonymsSaveCountryFirst"
                        :data-disabled="!item || !item._id || !item.synonyms"
                >
                    <synonyms
                            :item="item"
                    />
                </div>
            </app-tabs>

        </form>
    </app-content>
</template>

<script>
import getItemDetailMixin from 'mixins/getItemDetailMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import getLanguagesMixin from 'mixins/getLanguagesMixin'
import Synonyms from '../../components/Countries/Synonyms'
import {getCommonFormSubmit, setLoadingMessage} from 'utils/form'
import axios from 'axios'
import {VUE_APP_BASE_API_URL} from "@/constants/fileConstants";

const itemDetailMixin = getItemDetailMixin({
  apiMethodsSuffix: 'Country',
  parentRouteName: 'countries',
  storeModuleName: 'countries',
  storeItemName: 'country'
})

export default {
  name: 'country-item',
  mixins: [getLanguagesMixin, formatDateMixin, itemDetailMixin, appTitleMixin()],
  components: {
    Synonyms
  },
  created() {
    this.fetchLanguages();
    this.copyWatchedItem();
    this.countryLandscapeChanged = false;
    this.countryFlagChanged = false;
    this.params.tab = 0;
  },
  data() {
    return {
      columnTabs: [
        0,
        1
      ],
      watchedItem: {
          countryLandscape: null,
          countryFlag: null,
      },
      imagesUploading: false,
      countryLandscapeChanged: false,
      countryFlagChanged: false,
      countryLandscapeLink: null,
      countryFlagLink: null,
    }
  },
  methods: {
    copyWatchedItem() {
      Object.keys(this.watchedItem).forEach(v => (this.watchedItem[v] = this.item[v]));
    },
    async onFormSubmit(e) {
      this.errors.clear()

      this.formErrors = await this.runValidation()
      if (this.formErrors.items.length > 0) {
        this.appShowErrors(this.formErrors.items.map(v => v.msg))
        return
      }

      const commonFormSubmit = getCommonFormSubmit('Country')
      const response = await
      commonFormSubmit(this, e, { synonyms: (this.item.synonyms) ? this.item.synonyms : [] })
        .catch(err => err.response)
      const countryId = response.data.data._id;

      this.handleResponseIfError(response)

      if (this.countryLandscapeChanged || this.countryFlagChanged) {
          try {
              this.setImagesUploading(true);

              const { elements } = e.target;
              const imageApiUrl = VUE_APP_BASE_API_URL + 'country-image/';

              if (this.countryLandscapeChanged) {
                  const formData = new FormData();
                  const fileLandscape = elements.namedItem('countryLandscape').files[0];
                  if (fileLandscape) {
                      formData.set('fileExists', true);
                      formData.append('file', fileLandscape);
                  } else {
                      formData.set('fileExists', false);
                  }

                  formData.append('countryId', countryId);
                  formData.append('imageType', 'IMAGE_TYPE_LANDSCAPE');
                  await axios.post(imageApiUrl, formData);
              }

              if (this.countryFlagChanged) {
                  const formData = new FormData();
                  const fileFlag = elements.namedItem('countryFlag').files[0];
                  if (fileFlag) {
                      formData.set('fileExists', true);
                      formData.append('file', fileFlag);
                  } else {
                      formData.set('fileExists', false);
                  }

                  formData.append('countryId', countryId);
                  formData.append('imageType', 'IMAGE_TYPE_COUNTRY_FLAG');
                  await axios.post(imageApiUrl, formData);
              }

          } finally {
            this.setImagesUploading(false);
            this.resetImagesChanged();
          }
      }

      if (!this.backAllowed && response.status === 201) {
        this.goToDetail(response.data.data._id)
      }
    },
    async runValidation() {
      await this.errors.clear()
      await this.$validator.validateAll()
      return this.errors
    },
    onCountryLandscapeChanged() {
        this.countryLandscapeChanged = true;
        this.countryLandscapeLink = '';
    },
    onCountryFlagChanged() {
        this.countryFlagChanged = true;
        this.countryFlagLink = '';
    },
    resetImagesChanged() {
      this.countryFlagChanged = false
      this.countryLandscapeChanged = false
    },
    setImagesUploading(uploading) {
      this.imagesUploading = uploading
      setLoadingMessage(this, uploading ? 'Nahrávání obrázků...' : null)
    }
  },
  computed: {
    translations() {
      return {
        countryLandscape: this.$gettext('Obrázek na pozadí'),
        countryFlag: this.$gettext('Vlajka státu'),
        uploadCountryLandscape: this.$gettext('Nahrát obrázek na pozadí'),
        uploadCountryFlag: this.$gettext('Nahrát vlajku'),
        newCountry: this.$gettext('Nový stát'),
        basicInfo: this.$gettext('Základní údaje'),
        isoCode: this.$gettext('ISO 3166-1 alpha-3'),
        list: this.$gettext('Seznam'),
        showInDashboard: this.$gettext('Zobrazit v dashboardu'),
        synonyms: this.$gettext('Synonyma'),
        information: this.$gettext('Informace'),
        synonymsSaveCountryFirst: this.$gettext('Synonyma (nutné uložit stát)')
      }
    },
    deleting() {
      if (this.formItem.countryNames) {
        return false
      } else {
        return true
      }
    },
    currentTitle() {
      const itemName = this.item.countryNames ? this.item.countryNames[this.currentLanguageId] : this.$gettext('Nový stát')
      return [
        { name: this.$gettext('Státy'), link: { name: 'countries' } },
        itemName
      ]
    },
    countryTitleText() {
      return this.$gettext('Název státu v jazyku')
    }
  },
  watch: {
      item: {
          handler() {
              this.copyWatchedItem();
              if (this.item.images) {
                  if (this.item.images.IMAGE_TYPE_LANDSCAPE) {
                      this.countryLandscapeLink = this.item.images.IMAGE_TYPE_LANDSCAPE.imageLink;
                  }

                  if (this.item.images.IMAGE_TYPE_COUNTRY_FLAG) {
                      this.countryFlagLink = this.item.images.IMAGE_TYPE_COUNTRY_FLAG.imageLink;
                  }
              }
          },
          deep: true,
      }
  }
}
</script>
